import { render } from "./Input.vue?vue&type=template&id=871aa6b8&scoped=true"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=871aa6b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-871aa6b8"

export default script